import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { withStyles } from '@mui/styles';
import ContentAccordion from 'libraries/ContentAccordion';
import { withRouter } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import RetinaImage from 'react-retina-image';
import { getCandidateProctoringCapturedImages } from 'requests/AssessmentRequests';
import { formatTimestamp } from 'helper/commonFunctions';
import styles from './styles';
import CommentIcon from './comment.svg';

const ProctoringImages = observer(({ userAuditionId, classes, propPublic, gradeableCard }) => {
    const [capturedImages, setCapturedImages] = useState([]);

    useEffect(() => {
        let cancelled = false;

        async function load() {
            try {
                let apiPrefix = 'employer';
                if (propPublic) {
                    if (gradeableCard) {
                        apiPrefix = 'guest';
                    } else {
                        apiPrefix = 'public';
                    }
                }
                const images = await getCandidateProctoringCapturedImages(userAuditionId, apiPrefix);
                if (!cancelled && images?.success) {
                    setCapturedImages(images.data || []);
                }
            } catch (e) {
                if (!cancelled) {
                    setCapturedImages([]);
                }
            }
        }

        if (userAuditionId) load();

        return () => { cancelled = true; };
    }, [userAuditionId]);

    const Empty = () => (
        <div className={classes.empty}>
            <img src={CommentIcon} alt="" />
            <div className="title">Candidate Did Not Complete Assessment</div>
            <div className="text">This assessment required proctoring. The candidate did not provide consent for proctoring and therefore could not begin or complete the assessment. No responses or proctoring data are available for review.</div>
        </div>
    );

    return (
        <ContentAccordion
            className={classes.accordion}
            header={(
                <Typography className="u-mrg--bx2">
                    Proctoring Captured Image
                </Typography>
            )}
            content={
                capturedImages.length === 0 ? <Empty /> : (
                    <div className={classes.gallery}>
                        {capturedImages.map((image, idx) => (
                            <div className="image" key={idx}>
                                <span className="timestamp">{formatTimestamp(image.createdAt, 'full')}</span>
                                {
                                    image.cameraLabel && <span className="cameraLable">Camera: <span>{image.cameraLabel}</span></span>
                                }
                                <div className="picture">
                                    <RetinaImage src={image.file.fullFileUrl} alt="Proctoring capture" />
                                </div>
                            </div>
                        ))}
                    </div>
                )
            }
        />
    );
});

export default withStyles(styles)(withRouter(ProctoringImages));
